import { getURLParams } from "helpers/url";

export default function useQueryParams<T>(): T {
  const { search } = window.location;

  return getURLParams(search);
}
